import { AnyAction, Reducer } from 'redux';
import { SiteViewportAction, SiteViewportActionType } from '../../actions';
import { SITE_VIEWPORT_SIZE_PRESETS } from '../../constants';
import { SiteViewportState } from '../../state';
import produce from 'immer';

const DEFAULT_PRESET = SITE_VIEWPORT_SIZE_PRESETS.lg;

const initialState: SiteViewportState = {
  fullscreen: false,
  rotated: false,
  height: DEFAULT_PRESET.height,
  selectorVisible: false,
  width: DEFAULT_PRESET.width,
};

export const siteViewportReducer: Reducer<SiteViewportState, AnyAction> = (
  state: SiteViewportState = initialState,
  action: SiteViewportAction,
): SiteViewportState =>
  produce(state, (draft): void => {
    switch (action.type) {
      case SiteViewportActionType.SetFullscreen: {
        draft.fullscreen = action.fullscreen;
        return;
      }

      case SiteViewportActionType.SetRotated: {
        draft.rotated = action.rotated;
        return;
      }

      case SiteViewportActionType.SetSize: {
        draft.height = action.height || draft.height;
        draft.width = action.width || draft.width;
        return;
      }

      case SiteViewportActionType.SetSelectorVisible: {
        draft.selectorVisible = action.visible;
        return;
      }
    }
  });
